module.exports = __webpack_public_path__ + "img/p22.7e550c69.svg";